import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import styles from "./MoreInfo.module.scss";
import { faChevronDown } from "@fortawesome/pro-regular-svg-icons";

type MoreInfoProps = {
  infoExpanded: boolean;
  info: string;
};

export default function MoreInfo({ infoExpanded, info }: MoreInfoProps) {
  return (
    <>
      <div className={styles.moreInfo}>
        <FontAwesomeIcon icon={faChevronDown} />
        <p className={styles.label}>
          {infoExpanded ? "Info verbergen" : "Meer info"}
        </p>

        <div
          className={`${styles.absoluteWrapper} ${infoExpanded ? styles.expanded : ""}`}
        >
          <div className={styles.descriptionWrapper}>
            <p className={styles.description}>{info}</p>
          </div>
        </div>
      </div>
    </>
  );
}
